const AUTH_NOTICE_KEY = 'mac_auth_notice'
const DISABLED_ACCOUNT_MESSAGE = 'Your account has been disabled'

export type AuthNoticeKey = 'accountDisabled'

export function getAuthNoticeKeyFromError(message: string | null | undefined): AuthNoticeKey | null {
  if (!message) return null

  const normalizedMessage = message.trim().toLowerCase()
  if (normalizedMessage === DISABLED_ACCOUNT_MESSAGE.toLowerCase()) {
    return 'accountDisabled'
  }

  return null
}

export function persistAuthNotice(notice: AuthNoticeKey): void {
  try {
    window.sessionStorage.setItem(AUTH_NOTICE_KEY, notice)
  } catch {
    // Ignore storage failures and fall back to the immediate error handling path.
  }
}

export function consumeAuthNotice(): AuthNoticeKey | null {
  try {
    const stored = window.sessionStorage.getItem(AUTH_NOTICE_KEY)
    if (stored === 'accountDisabled') {
      window.sessionStorage.removeItem(AUTH_NOTICE_KEY)
      return stored
    }
  } catch {
    // Ignore storage failures and fall back to no persisted notice.
  }

  return null
}
